import NewReleaseReporting from './new-release-reporting';

export * from './new-release-reporting';
export default NewReleaseReporting;
